import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I'm tired – a poem",
  "description": "",
  "published": "2018-08-07T00:00:00.000Z",
  "redirect_from": ["/blog/tired-poem/swizec/8560"],
  "categories": "Personal, Writing",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I wrote this poem at a restaurant on Sunday, sipping on hot chai and a cup of chicken soup, waiting for a glorious steak salad to arrive. It was dark – nobody saw that I shed a tear or two. I think. If they did, they didn't say anything.`}</p>
    <p>{`The laptop screen lit my face up like a search light. 🤔`}</p>
    <p>{`It's a modern free verse poem. The kind I used to hate in high school because it's easy to make. You just write and don't give a shit about form or structure. Then you call it a poem.`}</p>
    <p>{`I wasn't going to publish it for fear of what people might say. But fuck it, that's no way to live a life. What would Amanda Palmer say.`}</p>
    <h2 {...{
      "id": "im-tired--a-poem"
    }}>{`I'm tired – a poem`}</h2>
    <p>{`I'm tired of my job`}</p>
    <p>{`I'm tired of my business`}</p>
    <p>{`I'm tired of proving myself to US immigration`}</p>
    <p>{`I'm tired of proving myself to my boss`}</p>
    <p>{`I'm tired of my shitty apartment`}</p>
    <p>{`and my home office where I can touch both walls`}</p>
    <p>{`I'm tired of my coworkers`}</p>
    <p>{`making noise eating at their desk`}</p>
    <p>{`I'm tired of the same lunch time conversations`}</p>
    <p>{`in the same lunch time spots`}</p>
    <p>{`at the same lunch time hours`}</p>
    <p>{`I'm tired of my routine`}</p>
    <p>{`I'm tired of my workouts`}</p>
    <p>{`I'm tired of trying to be my best`}</p>
    <p>{`I always just move my goals`}</p>
    <p>{`I'm tired of this city`}</p>
    <p>{`with its shitty streets`}</p>
    <p>{`and asphalt cracked so much it makes me fall`}</p>
    <p>{`I'm tired of knowing what I'll do on Friday when Monday isn't even started`}</p>
    <p>{`I'm tired of working on the same shit`}</p>
    <p>{`I'm tired of making content`}</p>
    <p>{`I'm tired of making my name`}</p>
    <p>{`I'm tired of ambition`}</p>
    <p>{`and I'm tired of knowing that, without ambition, I'd have nothing`}</p>
    <p>{`I'm tired of my girlfriend`}</p>
    <p>{`I'm tired of my bird`}</p>
    <p>{`I'm tired of delaying gratification`}</p>
    <p>{`gratification never comes`}</p>
    <p>{`I'm tired of seeing happy people and wondering if I'll ever be happy, too`}</p>
    <p>{`tired of knowing that I'd not feel happy even if I was`}</p>
    <p>{`I'm tired of spending my vacations to visit family`}</p>
    <p>{`I'm tired of paying for their flights`}</p>
    <p>{`I'm tired of doing the thing I'm supposed to`}</p>
    <p>{`when all I want is to do anything else`}</p>
    <p>{`I'm tired of boring problems`}</p>
    <p>{`I'm tired of other's shitty code`}</p>
    <p>{`I'm tired of being me`}</p>
    <p>{`and always picking up the pieces`}</p>
    <p>{`I'm tired of having everyone's backs`}</p>
    <p>{`when nobody has mine`}</p>
    <p>{`I'm tired of feeling like I'm drowning`}</p>
    <p>{`with all this weight upon my back`}</p>
    <p>{`I'm tired of not knowing how to share the load`}</p>
    <p>{`because others would just fuck it up`}</p>
    <p>{`I'm tired of being responsible`}</p>
    <p>{`I'm tired of being there for everyone`}</p>
    <p>{`I'm tired of the internet`}</p>
    <p>{`I'm tired of feeling all alone`}</p>
    <p>{`I'm tired of feeling like I can't relate`}</p>
    <p>{`and like I can't write whatever I want`}</p>
    <p>{`I'm tired of having an audience`}</p>
    <p>{`I'm tired of being an expert`}</p>
    <p>{`All I want is to do something completely new`}</p>
    <p>{`Something I've never done before`}</p>
    <p>{`And learning it all from scratch`}</p>
    <p>{`With no experience and no responsibility`}</p>
    <p>{`Just doing something fun for the sake of fun`}</p>
    <p>{`Wouldn't that be nice?`}</p>
    <p>{`I'm tired of feeling like I can't because I'd give up everything I always wanted`}</p>
    <p>{`I'm tired of being stuck`}</p>
    <p>{`in this place I fought so hard to get`}</p>
    <p>{`Stuck in a dream of a life I always wanted`}</p>
    <p>{`but actually not quite`}</p>
    <p>{`I am where I want to`}</p>
    <p>{`Doing what I love`}</p>
    <p>{`And I'm tired`}</p>
    <p>{`Tired of the crap I've piled on`}</p>
    <p>{`Tired of responsibility`}</p>
    <p>{`Tired of other people's feelings`}</p>
    <p>{`Tired of being afraid to share this poem`}</p>
    <p>{`Tired of everything being meh`}</p>
    <p>{`And life a little bleh`}</p>
    <p>{`Just, tired`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      